import React, { createContext, useContext, ReactNode } from 'react';
import { useSharedAlerts, IUseSharedAlertsReturn } from '../../../hooks/useSharedAlerts';
import AlertContainer from './AlertContainer';

interface IAlertProviderProps {
	children: ReactNode;
}

const AlertContext = createContext<IUseSharedAlertsReturn | undefined>(undefined);

/**
 * Global Alert Provider - provides alert functionality throughout the app
 * Wrap your app with this provider to use alerts globally
 */
export const AlertProvider: React.FC<IAlertProviderProps> = ({ children }) => {
	const alertMethods = useSharedAlerts();

	return (
		<AlertContext.Provider value={alertMethods}>
			{children}
			<AlertContainer alerts={alertMethods.alerts} onAlertClose={alertMethods.hideAlert} />
		</AlertContext.Provider>
	);
};

/**
 * Hook to use global alerts - requires AlertProvider wrapping the app
 */
export const useGlobalAlerts = (): IUseSharedAlertsReturn => {
	const context = useContext(AlertContext);
	if (!context) {
		throw new Error('useGlobalAlerts must be used within an AlertProvider');
	}
	return context;
};

export default AlertProvider;
